export { default as debounce } from './debounce';
export { default as when } from './when';
export { default as wait } from './wait';
export { default as equals } from './equals';

export { default as concat } from './concat';
export { default as increment } from './increment';
export { default as merge } from './merge';
export { default as pop } from './pop';
export { default as push } from './push';
export { default as set } from './set';
export { default as shift } from './shift';
export { default as splice } from './splice';
export { default as toggle } from './toggle';
export { default as unset } from './unset';
export { default as unshift } from './unshift';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/operators/index.js
// module id = 3
// module chunks = 5